export default __webpack_public_path__ + "media/Objective/Objective-Medium-401e7103c7033f55c7ce5d82868e7e53.woff2";